/**
 * Kayıt ekranlarının alabildiği hata kodları (gemi ve ofis kayıt uçları, LAN yüklemesi, masaüstü
 * ana süreci; ADR 0042 Ek U21, U24, U27, U30). Her birinin iki dilde metni vardır
 * (`forms.errors.<kod>`; `status.test.ts`); bilinmeyen kod genel metne düşer.
 */
export const FORM_RECORD_ERROR_CODES = [
  // Yetki, oturum, parola (§12) [MEPC.312 4.3.6]
  'FORBIDDEN',
  'NOT_FOUND',
  'UNAUTHENTICATED',
  'VALIDATION_FAILED',
  'INVALID_CREDENTIALS',
  'INVALID_PASSWORD',
  'REAUTHENTICATION_REQUIRED',
  'TOO_MANY_ATTEMPTS',
  'ROW_VERSION_CONFLICT',
  // Revizyon bağı ve kâğıt istisnası (§3)
  'REVISION_NOT_CURRENT',
  'REVISION_NOT_PUBLISHED',
  'REVISION_NOT_FOUND',
  'REVISION_MISMATCH',
  'NOT_A_FORM',
  'VESSEL_MISMATCH',
  'DOCUMENT_NOT_VISIBLE',
  'FILL_METHOD_UNSUPPORTED',
  'RECORD_BINDING_LOCKED',
  // Dosyalar (§6, §18)
  'FILE_NOT_ON_BOARD',
  'FILE_TOO_LARGE',
  'TOO_MANY_FILES',
  'NO_FILES',
  'EMPTY_FILE',
  'DUPLICATE_FILE',
  'UNSUPPORTED_FILE_TYPE',
  'FILE_TYPE_MISMATCH',
  'INVALID_FILE',
  'SHIP_FILE_MISSING',
  'HASH_MISMATCH',
  'FILES_UNAVAILABLE',
  'DISK_CRITICAL',
  // Durum ve işlem (§13, §14)
  'RECORD_SUBMITTED',
  'RECORD_VOID',
  'RECORD_DISCARDED',
  'RECORD_NOT_SUBMITTED',
  'ALREADY_VOIDED',
  'ALREADY_SUBMITTED',
  'INVALID_RECORD_STATE',
  'NOT_RETURNED',
  'NOT_PENDING',
  'NO_CHANGE',
  'REASON_REQUIRED',
  'REASON_TOO_LONG',
  'DISCARD_NOT_ALLOWED',
  'CONTENT_HASH_MISMATCH',
  // Onay (§9, §15, §16)
  'RETURN_REASON_REQUIRED',
  'LATE_REASON_REQUIRED',
  'STALE_DECISION',
  'CONTENT_CHANGED',
  'NO_ELIGIBLE_APPROVER',
  'NOT_APPROVER',
  // Form zinciri (ADR 0071 §3)
  'NOT_A_PREPARER',
  'SELF_APPROVAL_FORBIDDEN',
  'SAME_APPROVER_FORBIDDEN',
  'OFFICE_STEP',
  'NOT_OFFICE_STEP',
  'FILE_NOT_UPLOADED',
  'APPROVAL_RULE_MISSING',
  // Masaüstü ve önizleyici (§18, §19)
  'NO_ASSOCIATED_APP',
  'OPEN_FORM_NOT_OFFICE',
  'FILE_STILL_OPEN',
  'NO_WORKING_COPY',
  'UNCHANGED_TEMPLATE',
  'LOW_RESOLUTION',
  // Felixmate Office Pack (ADR 0070)
  'PDF_FAILED',
  'OFFICE_PACK_MISSING',
  'OPEN_FAILED',
  'READ_FAILED',
  'SHIP_UNREACHABLE',
  'PDF_HAS_SCRIPTS',
  'PDF_IS_XFA',
  'PDF_NO_FIELDS',
  // PDF indirilemedi ya da pdf.js açamadı: Fill in app nedenli pasif (2026-10-16)
  'PDF_FORM_CHECK_FAILED',
  'PREVIEW_NOT_READY',
  'POPUP_BLOCKED',
  'NETWORK',
] as const;

export type FormRecordErrorCode = (typeof FORM_RECORD_ERROR_CODES)[number];
